import { render, staticRenderFns } from "./mod.vue?vue&type=template&id=4c048655&scoped=true"
import script from "./mod.vue?vue&type=script&lang=js"
export * from "./mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c048655",
  null
  
)

export default component.exports